<script setup lang="ts">
defineProps<{
  disableSideSection?: boolean
}>()
</script>

<template>
  <div class="px-4 sm:flex sm:items-start sm:space-x-8 sm:px-0">
    <div :class="[disableSideSection ? 'sm:w-full' : 'sm:w-3/4']">
      <slot name="main"></slot>
    </div>
    <div class="sm:w-1/4" v-if="!disableSideSection">
      <slot name="aside"></slot>
    </div>
  </div>
</template>
